import ITableDataFetcher from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataFetcher';
import {
    Account,
    SlimUser,
    OrderBy,
    WebAccountModel,
    BrokerFilterRequest,
    AccountFilterRequest,
    GetAccountByIdRequest,
    Filter,

} from 'Core/Api/Api';
import TableRequest from 'Core/TableUtility/Models/TableRequest';
import ITableDataResponse from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataResponse';
import { SecuredClient } from 'Core/Api/SecuredClient';
import Utility from 'Core/Utility';

export default class JcsdAccountHandler implements ITableDataFetcher<Account> {
    constructor(props?: any) { }

    GetData(tableRequest: TableRequest): Promise<ITableDataResponse<Account>> {
        return this.GetAccounts(tableRequest);
    }


    AddAccount(request: WebAccountModel) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const requestAsFormData = Utility.ConvertToFormData(request);
        return client.addJcsdAccount(requestAsFormData);
    }

    EditAccount(request: WebAccountModel) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const requestAsFormData = Utility.ConvertToFormData(request);
        return client.editJcsdAccount(requestAsFormData);
    }

    ValidateAccount(request: WebAccountModel) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const requestAsFormData = Utility.ConvertToFormData(request);
        return client.validateAccount(requestAsFormData);
    }

    GetAccounts(tableRequest: TableRequest) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new AccountFilterRequest();
        request.amountPerPage = 500;
        request.filters = tableRequest?.filters?.map(x => 
            new Filter(x)
        );
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getAccounts(request);
    }

    GetAccountById(id: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetAccountByIdRequest();
        request.id = id;
        return client.getAccountById(request);
    }

    GetBrokers() {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const request = new BrokerFilterRequest();
        request.amountPerPage = 500;
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getBrokers(request);
    }
}



